import request from '@/utils/request'

export const getPrizeList = () =>
  request({ url: '/lottery/prize/list', method: 'get' })

export const savePrize = (data: any) =>
  request({ url: '/lottery/prize', method: 'post', data })

export const updatePrize = (data: any) =>
  request({ url: '/lottery/prize', method: 'put', data })

export const deletePrize = (id: number) =>
  request({ url: '/lottery/prize', method: 'delete', params: { id } })

export const getLotteryRecords = (params: any) =>
  request({ url: '/lottery/record/page', method: 'get', params })
